var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBusinessCustomer = function SvgBusinessCustomer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 59.262 51.12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f6f6f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.707 11.079h-9.218V5.534A5.68 5.68 0 0 0 38.954 0H20.483a5.68 5.68 0 0 0-5.534 5.534v5.534H5.706A5.68 5.68 0 0 0 .173 16.6v9.232h59.089V16.6a5.68 5.68 0 0 0-5.538-5.534Zm-16.6 0H22.334V7.385h14.773ZM55.62 32.442v13.054a2.2 2.2 0 0 1-2.075 2.165H5.62a2.2 2.2 0 0 1-2.162-2.075V32.442h15.24v2.075a5.31 5.31 0 0 0 5.306 5.306h11.079a5.313 5.313 0 0 0 5.306-5.306v-2.075h15.23m3.459-3.459H36.93v5.534a1.847 1.847 0 0 1-1.847 1.847H24.004a1.847 1.847 0 0 1-1.847-1.847v-5.534H0v16.6a5.68 5.68 0 0 0 5.535 5.534h48.01a5.68 5.68 0 0 0 5.534-5.534z"
  }))));
};
export default SvgBusinessCustomer;